// Adapter: bridges workbench-app's CommonToast API to this project's toast system
import { useCallback } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { showToast as dispatchToast } from '@/store/slices/toastSlice';

export const TOAST_TYPES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
} as const;

export type ToastType = (typeof TOAST_TYPES)[keyof typeof TOAST_TYPES];

const severityMap: Record<string, 'success' | 'error' | 'warning' | 'info'> = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export function useToast() {
  const dispatch = useAppDispatch();

  const showToast = useCallback(
    ({ message, type = TOAST_TYPES.INFO }: { message: string; type?: ToastType }) => {
      dispatch(dispatchToast({ message, severity: severityMap[type] ?? 'info' }));
    },
    [dispatch],
  );

  return { showToast };
}
